import { render, staticRenderFns } from "./Ongoing.vue?vue&type=template&id=6d3866c3&scoped=true"
import script from "./Ongoing.vue?vue&type=script&lang=js"
export * from "./Ongoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3866c3",
  null
  
)

export default component.exports